export interface StateData {
    state: string;
    code: string;
    cities: string[];
}

export const locationData: StateData[] = [
    {
        state: "Andaman and Nicobar Islands",
        code: "AN",
        cities: ["Port Blair", "Alipur", "Andaman Island", "Anderson Island", "Bamboo Flat", "Betapur", "Digilpur", "Havelock Island", "Long Island", "Mayabunder", "Nicobar Island", "Rangachang"]
    },
    {
        state: "Andhra Pradesh",
        code: "AP",
        cities: ["Adilabad", "Adoni", "Amalapuram", "Anakapalle", "Anantapur", "Bapatla", "Chittoor", "Cuddapah", "Eluru", "Guntur", "Kakinada", "Kurnool", "Nellore", "Ongole", "Rajahmundry", "Srikakulam", "Tirupati", "Vijayawada", "Visakhapatnam", "Vizianagaram"]
    },
    {
        state: "Arunachal Pradesh",
        code: "AR",
        cities: ["Itanagar", "Along", "Anini", "Basar", "Changlang", "Daporizo", "Khonsa", "Pasighat", "Roing", "Seppa", "Tawang", "Tezu", "Ziro"]
    },
    {
        state: "Assam",
        code: "AS",
        cities: ["Guwahati", "Barpeta", "Bongaigaon", "Dibrugarh", "Digboi", "Diphu", "Goalpara", "Golaghat", "Hailakandi", "Jorhat", "Karimganj", "Lakhimpur", "Nagaon", "Nalbari", "Sibsagar", "Silchar", "Tezpur", "Tinsukia"]
    },
    {
        state: "Bihar",
        code: "BR",
        cities: ["Patna", "Araria", "Arrah", "Aurangabad", "Begusarai", "Bettiah", "Bhagalpur", "Bihar Sharif", "Buxar", "Chhapra", "Darbhanga", "Gaya", "Gopalganj", "Hajipur", "Jamui", "Jehanabad", "Katihar", "Khagaria", "Kishanganj", "Lakhisarai", "Madhepura", "Madhubani", "Motihari", "Munger", "Muzaffarpur", "Nalanda", "Nawada", "Purnia", "Saharsa", "Samastipur", "Sasaram", "Sitamarhi", "Siwan", "Supaul", "Vaishali"]
    },
    {
        state: "Chandigarh",
        code: "CH",
        cities: ["Chandigarh"]
    },
    {
        state: "Chhattisgarh",
        code: "CT",
        cities: ["Raipur", "Ambikapur", "Bhilai", "Bilaspur", "Dantewada", "Durg", "Jagdalpur", "Janjgir", "Jashpur", "Kanker", "Kawardha", "Korba", "Mahasamund", "Rajnandgaon"]
    },
    {
        state: "Dadra and Nagar Haveli",
        code: "DN",
        cities: ["Silvassa"]
    },
    {
        state: "Daman and Diu",
        code: "DD",
        cities: ["Daman", "Diu"]
    },
    {
        state: "Delhi",
        code: "DL",
        cities: ["New Delhi", "Central Delhi", "East Delhi", "North Delhi", "North East Delhi", "North West Delhi", "South Delhi", "South West Delhi", "West Delhi"]
    },
    {
        state: "Goa",
        code: "GA",
        cities: ["Panaji", "Madgaon", "Mapusa", "Marmagao", "Ponda"]
    },
    {
        state: "Gujarat",
        code: "GJ",
        cities: ["Ahmedabad", "Amreli", "Anand", "Ankaleshwar", "Bharuch", "Bhavnagar", "Bhuj", "Dahod", "Gandhinagar", "Godhra", "Himmatnagar", "Jamnagar", "Junagadh", "Mehsana", "Morvi", "Nadiad", "Navsari", "Palanpur", "Porbandar", "Rajkot", "Surat", "Surendranagar", "Vadodara", "Valsad", "Vapi", "Veraval"]
    },
    {
        state: "Haryana",
        code: "HR",
        cities: ["Gurgaon", "Ambala", "Bhiwani", "Faridabad", "Fatehabad", "Hisar", "Jhajjar", "Jind", "Kaithal", "Karnal", "Kurukshetra", "Narnaul", "Panchkula", "Panipat", "Rewari", "Rohtak", "Sirsa", "Sonipat", "Yamunanagar"]
    },
    {
        state: "Himachal Pradesh",
        code: "HP",
        cities: ["Shimla", "Bilaspur", "Chamba", "Hamirpur", "Kangra", "Kullu", "Mandi", "Nahan", "Solan", "Una"]
    },
    {
        state: "Jammu and Kashmir",
        code: "JK",
        cities: ["Srinagar", "Jammu", "Anantnag", "Baramulla", "Doda", "Kathua", "Kupwara", "Poonch", "Pulwama", "Rajouri", "Udhampur"]
    },
    {
        state: "Jharkhand",
        code: "JH",
        cities: ["Ranchi", "Bokaro", "Chaibasa", "Chatra", "Daltonganj", "Deoghar", "Dhanbad", "Dumka", "Garhwa", "Giridih", "Godda", "Gumla", "Hazaribagh", "Jamshedpur", "Koderma", "Lohardaga", "Pakur", "Sahibganj"]
    },
    {
        state: "Karnataka",
        code: "KA",
        cities: ["Bengaluru", "Belgaum", "Bellary", "Bidar", "Bijapur", "Chikmagalur", "Chitradurga", "Davanagere", "Dharwad", "Gadag", "Gulbarga", "Hassan", "Haveri", "Hubli", "Kolar", "Mangalore", "Mysore", "Raichur", "Shimoga", "Tumkur", "Udupi"]
    },
    {
        state: "Kerala",
        code: "KL",
        cities: ["Thiruvananthapuram", "Alappuzha", "Cochin", "Ernakulam", "Idukki", "Kannur", "Kasaragod", "Kochi", "Kollam", "Kottayam", "Kozhikode", "Malappuram", "Palakkad", "Pathanamthitta", "Thrissur", "Wayanad"]
    },
    {
        state: "Ladakh",
        code: "LA",
        cities: ["Leh", "Kargil"]
    },
    {
        state: "Lakshadweep",
        code: "LD",
        cities: ["Kavaratti", "Agatti", "Minicoy"]
    },
    {
        state: "Madhya Pradesh",
        code: "MP",
        cities: ["Bhopal", "Balaghat", "Betul", "Bhind", "Chhatarpur", "Chhindwara", "Damoh", "Datia", "Dewas", "Dhar", "Guna", "Gwalior", "Hoshangabad", "Indore", "Jabalpur", "Katni", "Khandwa", "Khargone", "Mandsaur", "Morena", "Narsinghpur", "Neemuch", "Ratlam", "Rewa", "Sagar", "Satna", "Sehore", "Seoni", "Shahdol", "Shajapur", "Shivpuri", "Ujjain", "Vidisha"]
    },
    {
        state: "Maharashtra",
        code: "MH",
        cities: ["Mumbai City", "Mumbai suburban", "Ahmednagar", "Akola", "Amravati", "Aurangabad", "Beed", "Bhandara", "Buldhana", "Chandrapur", "Dhule", "Gadchiroli", "Gondia", "Jalgaon", "Jalna", "Kalyan", "Kolhapur", "Latur", "Nagpur", "Nanded", "Nandurbar", "Nashik", "Osmanabad", "Parbhani", "Pune", "Ratnagiri", "Sangli", "Satara", "Solapur", "Thane", "Wardha", "Washim", "Yavatmal"]
    },
    {
        state: "Manipur",
        code: "MN",
        cities: ["Imphal", "Bishnupur", "Chandel", "Churachandpur", "Senapati", "Thoubal", "Ukhrul"]
    },
    {
        state: "Meghalaya",
        code: "ML",
        cities: ["Shillong", "Jowai", "Nongpoh", "Nongstoin", "Tura", "Williamnagar"]
    },
    {
        state: "Mizoram",
        code: "MZ",
        cities: ["Aizawl", "Champhai", "Kolasib", "Lunglei", "Saiha", "Serchhip"]
    },
    {
        state: "Nagaland",
        code: "NL",
        cities: ["Kohima", "Dimapur", "Mokokchung", "Mon", "Phek", "Tuensang", "Wokha", "Zunheboto"]
    },
    {
        state: "Odisha",
        code: "OR",
        cities: ["Bhubaneswar", "Angul", "Balasore", "Bargarh", "Berhampur", "Bhadrak", "Bolangir", "Cuttack", "Dhenkanal", "Jagatsinghpur", "Jajpur", "Jharsuguda", "Kendrapara", "Keonjhar", "Koraput", "Mayurbhanj", "Nayagarh", "Puri", "Rayagada", "Rourkela", "Sambalpur", "Sundergarh"]
    },
    {
        state: "Puducherry",
        code: "PY",
        cities: ["Puducherry", "Karaikal", "Mahe", "Yanam"]
    },
    {
        state: "Punjab",
        code: "PB",
        cities: ["Amritsar", "Barnala", "Bathinda", "Faridkot", "Fatehgarh Sahib", "Ferozepur", "Gurdaspur", "Hoshiarpur", "Jalandhar", "Kapurthala", "Ludhiana", "Mansa", "Moga", "Muktsar", "Pathankot", "Patiala", "Rupnagar", "Sangrur", "Tarn Taran"]
    },
    {
        state: "Rajasthan",
        code: "RJ",
        cities: ["Jaipur", "Ajmer", "Alwar", "Banswara", "Baran", "Barmer", "Bharatpur", "Bhilwara", "Bikaner", "Bundi", "Chittorgarh", "Churu", "Dausa", "Dholpur", "Dungarpur", "Hanumangarh", "Jaisalmer", "Jalore", "Jhalawar", "Jhunjhunu", "Jodhpur", "Kota", "Nagaur", "Pali", "Sawai Madhopur", "Sikar", "Sirohi", "Sri Ganganagar", "Tonk", "Udaipur"]
    },
    {
        state: "Sikkim",
        code: "SK",
        cities: ["Gangtok", "Mangan", "Namchi", "Gyalshing"]
    },
    {
        state: "Tamil Nadu",
        code: "TN",
        cities: ["Chennai", "Coimbatore", "Cuddalore", "Dharmapuri", "Dindigul", "Erode", "Hosur", "Kanchipuram", "Kanyakumari", "Karur", "Madurai", "Nagapattinam", "Namakkal", "Ooty", "Perambalur", "Pudukkottai", "Ramanathapuram", "Salem", "Sivaganga", "Thanjavur", "Theni", "Thiruvallur", "Thiruvarur", "Tiruchirappalli", "Tirunelveli", "Tirupur", "Tiruvannamalai", "Tuticorin", "Vellore", "Villupuram", "Virudhunagar"]
    },
    {
        state: "Telangana",
        code: "TG",
        cities: ["Hyderabad", "Adilabad", "Karimnagar", "Khammam", "Mahbubnagar", "Medak", "Nalgonda", "Nizamabad", "Rangareddy", "Warangal"]
    },
    {
        state: "Tripura",
        code: "TR",
        cities: ["Agartala", "Ambassa", "Kailashahar", "Udaipur"]
    },
    {
        state: "Uttar Pradesh",
        code: "UP",
        cities: ["Lucknow", "Agra", "Aligarh", "Allahabad", "Ambedkar Nagar", "Auraiya", "Azamgarh", "Baghpat", "Bahraich", "Ballia", "Balrampur", "Banda", "Barabanki", "Bareilly", "Basti", "Bijnor", "Budaun", "Bulandshahr", "Chandauli", "Chitrakoot", "Deoria", "Etah", "Etawah", "Faizabad", "Farrukhabad", "Fatehpur", "Firozabad", "Gautam Buddh Nagar", "Ghaziabad", "Ghazipur", "Gonda", "Gorakhpur", "Hamirpur", "Hardoi", "Hathras", "Jalaun", "Jaunpur", "Jhansi", "Jyotiba Phule Nagar", "Kannauj", "Kanpur", "Kaushambi", "Kheri", "Kushinagar", "Lalitpur", "Maharajganj", "Mahoba", "Mainpuri", "Mathura", "Mau", "Meerut", "Mirzapur", "Moradabad", "Muzaffarnagar", "Noida", "Pilibhit", "Pratapgarh", "Raebareli", "Rampur", "Saharanpur", "Sant Kabir Nagar", "Sant Ravidas Nagar", "Shahjahanpur", "Shravasti", "Siddharthnagar", "Sitapur", "Sonbhadra", "Sultanpur", "Unnao", "Varanasi"]
    },
    {
        state: "Uttarakhand",
        code: "UT",
        cities: ["Dehradun", "Almora", "Bageshwar", "Chamoli", "Champawat", "Haridwar", "Nainital", "Pauri Garhwal", "Pithoragarh", "Rudraprayag", "Tehri Garhwal", "Udham Singh Nagar", "Uttarkashi"]
    },
    {
        state: "West Bengal",
        code: "WB",
        cities: ["Kolkata", "Asansol", "Bankura", "Bardhaman", "Birbhum", "Cooch Behar", "Darjeeling", "Hooghly", "Howrah", "Jalpaiguri", "Malda", "Midnapore", "Murshidabad", "Nadia", "North 24 Parganas", "Purulia", "Siliguri", "South 24 Parganas", "Uttar Dinajpur"]
    }
];
